import './App.js';
import * as modules from './modules';
//import './modules/index.js';
import {multipleBannerSwiper, sliderNews, sliderProducts} from './swiper-configs';
import {detectBlockOnScreen} from './utils/animation-triger'


const selectorSlider = {
    bannerMultiple: `.slider-banner--multiple`,
    bannerSingle: `.slider-banner--single`,
    news: `.slider-news`,
    products: `.slider-products`,
};

$(window).on('DOMContentLoaded', function () {
    if (document.querySelectorAll(selectorSlider.bannerMultiple)[0]) {
        multipleBannerSwiper.init();
    }

    if (document.querySelectorAll(selectorSlider.news)[0]) {
        setTimeout(function () {
            if (sliderNews) {
                sliderNews.init();
            }
        }, 500);
    }

    if (document.querySelectorAll(selectorSlider.bannerSingle)[0]) {
        detectBlockOnScreen();
    }

    if (document.querySelectorAll(selectorSlider.products)[0]) {
        sliderProducts.init();
    }

});

